import React from "react";
import { useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

const articles = [
  {
    id: 1,
    date: "10-3-2025",
    title:
      "We educate women because it is smart. We educate women because it changes the world. - Drew Faust",
    content: `We educate women because it is smart. We educate women because it changes the world. - Drew Faust.

Momoi's journey exemplifies the mission of the Maasai Girls Rescue Center, where she and over 70 other Maasai girls have found a nurturing environment that empowers them through quality education, life skills training, and personalized development. Through this video, we witness how organizations like MGRC are breaking barriers, fostering self-sufficiency, and creating pathways for a brighter future for Maasai girls.

To support the Maasai Girls Rescue Center, visit their website here - https://maasairescue.org

This film is funded by the Impact Stories Fund and captured by the talented crew from @papricut and distributed by @sparkpublicity.

#InternationalWomensDay #AccelerateAction #IWD2025 #GirlsEducation #MaasaiGirlsRescueCenter #EmpowerThroughEducation`,
    videoId: "F0rWdvJxtEg",
  },
  {
    id: 2,
    date: "10-3-2025",
    title: "Maasai Girls Rescue Center - Tanzania",
    content: `As we continue to mark International Women's Day, we celebrate the resilience and potential of Maasai girls through the inspiring story of Momoi Daniely, a resident at the Maasai Girls Rescue Center in Tanzania.

Momoi's journey exemplifies the mission of the Maasai Girls Rescue Center, where she and over 70 other Maasai girls have found a nurturing environment that empowers them through quality education, life skills training, and personalized development. Through this video, we witness how organizations like MGRC are breaking barriers, fostering self-sufficiency, and creating pathways for a brighter future for Maasai girls.

As we honor Momoi and countless other Maasai girls on this special day, let us recognize the power of education to transform lives, break barriers, and forge new paths toward a brighter future.

To support the Maasai Girls Rescue Center, visit their website here - https://maasairescue.org

This film is funded by the Impact Stories Fund and captured by the talented crew from Papricut.com and distributed by SPARK Publicity.

#InternationalWomensDay #AccelerateAction #IWD2025 #GirlsEducation #MaasaiGirlsRescueCenter #EmpowerThroughEducation`,
    videoId: "Fh5GENKLGaM",
  },
  {
    id: 3,
    date: "14-1-2026",
    title: "THE FUTURE IS HERS – Sylvia’s Story | Kisii, Kenya",
    content: `Healthcare does more than heal bodies, it restores dignity, unlocks potential, and keeps hope alive. For Sylvia, a young girl from Kisii, Kenya, access to quality healthcare made all the difference.

After developing clubfoot in her left leg following an injection, Sylvia’s future felt uncertain. With timely medical care and compassionate support, her journey took a powerful new direction.

At AIC CURE Children’s Hospital in Kijabe, she received corrective surgery as part of the hospital’s mission to provide free, life-changing surgeries to children under 18. Through the dedication of skilled doctors and caregivers, Sylvia now walks confidently toward a brighter future, free from pain and limitation.

Sylvia’s story proves that no setback is greater than hope. It’s not just about healing a leg, it’s about reclaiming possibility.

To learn more about AIC CURE Children’s Hospital, visit www.kenya.cure.org

This film is funded by the Impact Stories Fund.`,
    videoId: "9X-C8kK68EM?si=hjkNHc_o2es_2Efk",
  }
];

const formatContent = (text) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g; // Detects links
  const hashtagRegex = /#(\w+)/g; // Detects hashtags
  const atRegex = /@(\w+)/g;

  return text.split("\n\n").map((paragraph, index) => (
    <p key={index}>
      {paragraph.split(" ").map((word, i) => {
        if (word.match(urlRegex)) {
          return (
            <a
              key={i}
              href={word}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary"
            >
              {word}{" "}
            </a>
          );
        } else if (word.match(hashtagRegex)) {
          return (
            <span key={i} className="text-primary">
              {word}{" "}
            </span>
          );
        } else if (word.match(atRegex)) {
          return (
            <span key={i} className="text-primary">
              {word}{" "}
            </span>
          );
        }
        return word + " ";
      })}
    </p>
  ));
};

const ImpactDetail = () => {
  const { id } = useParams();
  const article = articles.find((article) => article.id === parseInt(id));

  if (!article) {
    return <h2 className="text-center mt-5">Article Not Found</h2>;
  }

  return (
    <div className="container mt-5">
      <h2 className="text-center">{article.title}</h2>
      <p className="text-muted text-center">{article.date}</p>

      {/* Large Video with Responsive Centering */}
      <div className="d-flex justify-content-center my-4">
        <div className="w-75">
          <div className="embed-responsive embed-responsive-16by9">
            <iframe
              className="embed-responsive-item w-100"
              style={{ minHeight: "400px" }}
              src={`https://www.youtube.com/embed/${article.videoId}`}
              allowFullScreen
              title={article.title}
            ></iframe>
          </div>
        </div>
      </div>

      {/* Render formatted content */}
      <div className="mt-4">{formatContent(article.content)}</div>

      <a href="/impact" className="btn btn-secondary mt-3 mb-3">
        Back to Articles
      </a>
    </div>
  );
};

export default ImpactDetail;
